import { Spin, Tabs } from "antd"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { useSearchParams } from "react-router-dom"
import { useSelector } from "react-redux"
import { modelSelector } from "store/selectors"
import { PageName } from "ui/PageName"
import { ProgressBar } from "ui/ProgressBar"
import { PageTitle } from "layoutsV2/pro/ProNewListingLayout/PageTitle"
import { getStepConfig } from "./constants/stepConfig"
import { useExperienceWizard } from "./useExperienceWizard"
import { WizardActionButtons } from "./WizardActionButtons"
import { DetailsStep } from "./steps/DetailsStep"
import { SchedulingStep } from "./steps/SchedulingStep"
import { MediaStep } from "./steps/MediaStep"
import { ResourcesStep } from "./steps/ResourcesStep"
import { LocationStep } from "./steps/LocationStep"
import { WaiverStep } from "./steps/WaiverStep"
import { PreviewStep } from "./steps/PreviewStep"
import styles from "layoutsV2/pro/ProNewListingLayout/ProNewListingLayout.module.css"

const STEP_COMPONENTS = {
  details: DetailsStep,
  scheduling: SchedulingStep,
  media: MediaStep,
  resources: ResourcesStep,
  location: LocationStep,
  digital_waiver: WaiverStep,
  preview: PreviewStep
}

export const WizardLayout = () => {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const trip = useSelector(modelSelector("trip"))
  const isFetching = useSelector((state) => state.trips.trip.loading)
  const { currentStep, isSaving, handleStepClick } = useExperienceWizard()

  const routeType = searchParams.get("route") // "published" | "deactivated" | null
  const isEditMode = Boolean(routeType)

  const stepConfig = useMemo(() => getStepConfig(), [])
  const currentConfig = stepConfig.find((s) => s.id === currentStep) || stepConfig[0]
  const tabItems = useMemo(() => stepConfig.map(({ id, label }) => ({ key: id, label })), [stepConfig])

  const StepComponent = STEP_COMPONENTS[currentStep] || DetailsStep

  const pageTitle = isEditMode && trip?.title ? (
    <span>
      {t("listings.edit_new")} · <span style={{ color: "var(--color-primary)" }}>{trip.title}</span>
    </span>
  ) : (
    t("listings.create_new")
  )

  return (
    <Spin spinning={isSaving || isFetching} size="large">
      <div className={styles.layout}>
        <div className={styles.header}>
          {!isEditMode && <ProgressBar percent={currentConfig.percent} />}
          <PageName title={pageTitle} />
          <Tabs activeKey={currentStep} items={tabItems} onChange={handleStepClick} />
        </div>
        <div className={styles.body}>
          <PageTitle title={currentConfig.title} subTitle={currentConfig.subTitle} />
          <div className={styles.pageContent}>
            <div style={{ paddingBottom: "100px" }}>
              <StepComponent />
            </div>
          </div>
        </div>
      </div>
      <WizardActionButtons />
    </Spin>
  )
}
